import { v4 as uuidv4 } from 'uuid';
export * from './trackerRegistry';
export * from './deprecatedTracking';
export const trackProductEvent = (args) => {
    return {
        name: 'trackProduct',
        payload: args,
        id: uuidv4()
    };
};
export const trackCartCheckoutEvent = (args) => {
    return {
        name: 'trackCartCheckout',
        payload: args,
        id: uuidv4()
    };
};
export const trackCartEvent = (args) => {
    return {
        name: 'trackCart',
        payload: args,
        id: uuidv4()
    };
};
export const trackListEvent = (args) => {
    return {
        name: 'trackList',
        payload: args,
        id: uuidv4()
    };
};
export const trackPageEvent = (args) => {
    return {
        name: 'trackPageView',
        payload: args,
        id: uuidv4()
    };
};
export const trackUserEvent = (args) => {
    return {
        name: 'trackUser',
        payload: args,
        id: uuidv4()
    };
};
export const trackLoginEvent = () => {
    return {
        name: 'trackLogin',
        id: uuidv4()
    };
};
export const trackRegisterEvent = () => {
    return {
        name: 'trackRegister',
        id: uuidv4()
    };
};
export const trackAddToWishListEvent = (args) => {
    return {
        name: 'trackAddToWishList',
        payload: args,
        id: uuidv4()
    };
};
export const trackExperimentEvent = (args) => {
    return {
        name: 'trackExperiment',
        payload: args,
        id: uuidv4()
    };
};
//# sourceMappingURL=tracking.js.map